import { Dialog, DialogContent, DialogContentText, DialogActions, Button, Slide } from '@material-ui/core';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

function ConfirmationDialog(props) {
  const { message, handleClose } = props;
  return (
    <Dialog
      keepMounted
      TransitionComponent={Transition}
      open={!!message}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
